__turbopack_context__.v({
  "resources": "resources-module-scss-module__wWopva__resources",
  "resourcesHeader": "resources-module-scss-module__wWopva__resourcesHeader",
  "resourcesHeaderContent": "resources-module-scss-module__wWopva__resourcesHeaderContent",
  "resourcesHeaderContentDescription": "resources-module-scss-module__wWopva__resourcesHeaderContentDescription",
  "resourcesHeaderContentTitle": "resources-module-scss-module__wWopva__resourcesHeaderContentTitle",
  "resourcesHeaderImage": "resources-module-scss-module__wWopva__resourcesHeaderImage",
  "resourcesHeaderImageContainer": "resources-module-scss-module__wWopva__resourcesHeaderImageContainer",
  "resourcesHeaderImageWrapper": "resources-module-scss-module__wWopva__resourcesHeaderImageWrapper",
  "resourcesSuperTitle": "resources-module-scss-module__wWopva__resourcesSuperTitle",
});
